<div class="Footer_bottom">
    <section class="partner-comp page-hero-section d-flex flex-column align-items-center justify-content-center mb-5" [ngStyle]="(pageHero && pageHero.banner) ? {'background-image': 'url(' + pageHero.banner + ')'} : {}">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="col text-center">
                        <h1 class="page-hero-title">{{ pageTitle }}</h1>
                        <div *ngIf="pageHero && pageHero.subTitle">
                            <div class="page-hero-subtitle text-center cms-content" [innerHTML]="pageHero.subTitle | sanitizeHtml"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="partners-coming-soon d-flex flex-column align-items-center justify-content-center my-5">
        <p class="partners-coming-soon__title">Coming soon</p>
        <p class="partners-coming-soon__text">We are updating our partners section. Please check back later.</p>
    </section>
</div>
